import { useAppDispatch, useAppSelector } from 'hooks'
import { useEffect } from 'react'
import { Navigate, Outlet, useSearchParams } from 'react-router-dom'
import { isLoggedInSelector, setIsLoggedIn } from 'redux/store/slices/authSlice'
import TokenService from 'services/token.service'

const ProtectedRoute = () => {
  const dispatch = useAppDispatch()

  const [searchParams] = useSearchParams()

  const isAuth = useAppSelector(isLoggedInSelector)

  useEffect(() => {
    const token = searchParams.get('token')

    if (token) {
      TokenService.setJWTTokens({ access: token, refresh: '' })
      dispatch(setIsLoggedIn(true))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams])

  if (!isAuth) return <Navigate to={'/'} />

  return <Outlet />
}

export default ProtectedRoute
